import React from 'react';

const Input = ({ label, error, className = '', ...props }) => {
  return (
    <div className="space-y-1.5">
      {label && <label className="text-sm font-medium text-zinc-400 ml-1">{label}</label>}
      <input 
        className={`w-full bg-zinc-900/50 border ${error ? 'border-red-500 focus:ring-red-500/20' : 'border-zinc-800 focus:border-red-500 focus:ring-red-500/20'} rounded-xl px-4 py-3 text-white placeholder-zinc-500 focus:outline-none focus:ring-4 transition-all duration-200 ${className}`} 
        {...props} 
      />
      {error && <p className="text-xs text-red-500 font-medium ml-1">{error}</p>}
    </div>
  );
};

export default Input;